// extracted by mini-css-extract-plugin
export default {"normalLogo":"main_footer_circle_normalLogo__Ft6bw","hoveredLogo":"main_footer_circle_hoveredLogo__Ma97L","content":"main_footer_circle_content__AWrVK"};